import instance from "./axios";

export interface SemesterResponse {
    readonly id: string;
    readonly description: string;
}

export const callGetSemesters = () => instance.get<SemesterResponse[]>("api/semesters");

export const callGetSemesterById = (id: string) => instance.get<SemesterResponse>("api/semesters/" + id);